import theme from '@theme/FolxTheme';

const confetti = (props = {}) => {
	return {
		angledSpread: {
			left: {
				particleCount: 2,
				angle: 60,
				spread: 55,
				origin: { x: 0, y: 0.3 },
				colors: ['#ffa1d3', '#c79aff'],
				shapes: ['circle'],
				scalar: 1.5,
				startVelocity: 25,
				disableForReducedMotion: true,
				...props,
			},
			right: {
				particleCount: 2,
				angle: 120,
				spread: 55,
				origin: { x: 1, y: 0.3 },
				colors: ['#ffa1d3', '#c79aff'],
				shapes: ['circle'],
				scalar: 1.5,
				startVelocity: 25,
				disableForReducedMotion: true,
				...props,
			},
		},
		membershipSpread: {
			left: {
				particleCount: 4,
				angle: 60,
				spread: 55,
				origin: { x: 0, y: 0.3 },
				colors: ['#ffa1d3', '#c79aff', '#ffff03', '#ff9999'],
				shapes: ['circle', 'square'],
				scalar: 1.5,
				startVelocity: 25,
				disableForReducedMotion: true,
				...props,
			},
			right: {
				particleCount: 4,
				angle: 120,
				spread: 55,
				origin: { x: 1, y: 0.3 },
				colors: ['#ffa1d3', '#c79aff', '#ffff03', '#ff9999'],
				shapes: ['circle', 'square'],
				scalar: 1.5,
				startVelocity: 25,
				disableForReducedMotion: true,
				...props,
			},
		},
	};
};

export default confetti;
